<template>
    <section class="section">
        <div class="container">
            <page-header :title="title()">
                <button
                    class="button is-default mr-2"
                    @click="resetFilters"
                    :disabled="!activeFilters">
                    Nultil filtre
                </button>
                <button
                    class="button is-default mr-2"
                    :class="{ 'has-text-weight-bold': lowStockFilterActive }"
                    @click="toggleLowStock"
                    :disabled="lowStockCount==0">
                    Lav lagerbeholdning ({{ lowStockCount }})
                </button>
                <button
                    class="button is-default mr-2"
                    @click="openSerials">
                    Serienumre
                </button>
                <button
                    class="button is-primary mr-2"
                    @click="openModal(null)">
                    Opret
                </button>
                <b-dropdown position="is-bottom-left" v-if="$store.getters.isAdmin">
                    <template #trigger="">
                        <b-button
                            type="is-primary"
                            icon-right="file-upload" />
                    </template>

                    <b-dropdown-item @click="openDialog('itemImport')">Importér varer</b-dropdown-item>
                    <b-dropdown-item @click="openImportHelpModal()">Hjælp til import</b-dropdown-item>
                    <b-dropdown-item @click="openDialog('stockImport')">Opdater lagerstatus u. serienummer</b-dropdown-item>
                </b-dropdown>
                <b-dropdown position="is-bottom-left" v-if="$store.getters.isAdmin">
                    <template #trigger="">
                        <b-button
                            type="is-primary"
                            icon-right="file-download" />
                    </template>

                    <b-dropdown-item @click="noSerialExport()">Varer u. serienummer</b-dropdown-item>
                    <b-dropdown-item @click="withSerialExport()">Varer m. serienummer</b-dropdown-item>
                    <b-dropdown-item @click="serviceExort()">Service / ydelser</b-dropdown-item>
                    <b-dropdown-item @click="stockLocationExportNoSerial()">Lagerstatus pr. lokation u. serienummer</b-dropdown-item>
                    <b-dropdown-item @click="stockLocationExportWithSerial()">Lagerstatus pr. lokation m. serienummer</b-dropdown-item>
                    <b-dropdown-item @click="stockExportNoSerial()">Lagerstatus u. serienummer</b-dropdown-item>
                    <b-dropdown-item @click="stockExportWithSerial()">Lagerstatus m. serienummer</b-dropdown-item>
                    <b-dropdown-item @click="stockLocationExportWithAndWithoutSerial()">Lagerstatus m. og u. serienummer</b-dropdown-item>

                </b-dropdown>
                <input type="file" ref="itemImport" class="is-hidden" @change="itemImport" v-if="$store.getters.isAdmin">
                <input type="file" ref="stockImport" class="is-hidden" @change="stockImport" v-if="$store.getters.isAdmin">
            </page-header>

            <div class="field">
                <input v-model="query" class="input"
                        @keydown.tab.prevent="disableTab"
                       placeholder="Søg efter fabrikant, leverandør, model, toldkode, beskrivelse, serienummer, id... "
                       type="search" @input="search()">
            </div>

            <div class="is-flex is-justify-content-space-between is-align-items-start">
                <div class="field is-grouped is-grouped-multiline">
                    <b-select v-model="itemTypeId" @input="updateParamsAndFetch">
                        <option :value="0">Alle varetyper</option>
                        <option
                            v-for="type in listItemTypes"
                            :value="type.id"
                            :key="type.id">
                            {{ type.name }}
                        </option>
                    </b-select>
                    <b-select v-model="manufacturerId" @input="updateParamsAndFetch">
                        <option :value="0">Alle fabrikanter</option>
                        <option
                            v-for="manufacturer in listManufacturers"
                            :value="manufacturer.id"
                            :key="manufacturer.id">
                            {{ manufacturer.name }}
                        </option>
                    </b-select>
                    <b-select v-model="supplierId" @input="updateParamsAndFetch">
                        <option :value="0">Alle leverandører</option>
                        <option
                            v-for="supplier in listSuppliers"
                            :value="supplier.id"
                            :key="supplier.id">
                            {{ supplier.name }}
                        </option>
                    </b-select>
                    <InputSelectSearch
                        class="control"
                        style="min-width: 250px;"
                        v-model="location"
                        :options="listLocations"
                        label="full_name"
                        option-value-prop="id"
                        placeholder="Alle lokationer"
                        @input="updateParamsAndFetch"
                        :filter="filterLocations"
                    />
                    <b-select v-model="priceTypeId" @input="updateParamsAndFetch">
                        <option :value="0">Alle pristyper</option>
                        <option
                            v-for="priceType in listPriceTypes"
                            :value="priceType.id"
                            :key="priceType.id">
                            {{ priceType.name }}
                        </option>
                    </b-select>
                    <b-select v-model="subcategoryId" @input="updateParamsAndFetch">
                        <option :value="0">Alle kategorier</option>
                        <optgroup v-for="category in itemCategoryOptions" :key="category.id" :label="category.name">
                            <option v-for="subcategory in category.subcategoriesFlatten" :key="subcategory.id" :value="subcategory.id">
                                {{ subcategory.name }}
                            </option>
                        </optgroup>
                    </b-select>
                    <b-select v-model="soldOnWebShop" @input="updateParamsAndFetch">
                        <option :value="0">Alle varer</option>
                        <option :value="true">Sælges på webshop</option>
                        <option :value="false">Sælges ikke på webshop</option>
                    </b-select>
                </div>
                <div class="is-flex">
                    <div class="control is-flex is-align-items-center">
                        <button class="button is-rounded is-small"
                                :class="[displayType === 'list' ? 'is-link' : 'is-outlined']"
                                @click="toggleDisplayType('list')">
                            <i class="fas fa-list fa-stack-1x"></i>
                        </button>
                        <button class="button is-rounded is-small ml-1"
                                :class="[displayType === 'grid' ? 'is-link' : 'is-outlined']"
                                @click="toggleDisplayType('grid')">
                            <i class="fas fa-th fa-stack-1x"></i>
                        </button>
                    </div>
                    <b-pagination
                        class="is-hidden-touch is-hidden-desktop-only hide-dots control ml-2"
                        v-model="currentPage"
                        :per-page="pagination.per_page"
                        :total="pagination.total"
                        @change="paginate"
                        order="is-left">
                        <template v-slot:default>

                        </template>
                    </b-pagination>
                </div>
            </div>

            <transition-group name="slide-fade" mode="out-in">
                <div key="list" v-if="displayType === 'list'">
                    <div class="table-responsive">
                        <table class="table is-fullwidth min-width inventory">
                            <thead>
                            <tr>
                                <th @click="onUpdateOrderBy('model')" class="is-clickable">
                                    <div style="display: flex;">
                                        Model
                                        <SortArrow :orderBy="orderBy" field="model" :direction="direction"/>
                                    </div>
                                </th>
                                <th @click="onUpdateOrderBy('manufacturers.name')" class="is-clickable">
                                    <div style="display: flex;">
                                        Fabrikant
                                        <SortArrow :orderBy="orderBy" field="manufacturers.name" :direction="direction"/>
                                    </div>
                                </th>
                                <th>Beskrivelse</th>
                                <th @click="onUpdateOrderBy('stock_count_total')" class="is-clickable has-text-right">
                                    <div style="display: flex;">
                                        <span style="white-space: nowrap;">På lager</span>
                                        <SortArrow :orderBy="orderBy" field="stock_count_total" :direction="direction"/>
                                    </div>
                                </th>
                                <th v-if="lowStockFilterActive" @click="onUpdateOrderBy('reordered_at')" class="is-clickable has-text-right">
                                    <div style="display: flex;">
                                        Genbestilt?
                                        <SortArrow :orderBy="orderBy" field="reordered_at" :direction="direction"/>
                                    </div>
                                </th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody v-if="!isFetching">
                            <tr
                                v-for="item in items"
                                :key="item.id">
                                <td class="model" @click="openItem(item.id)">{{ item.model }}</td>
                                <td class="manufacturer" @click="openItem(item.id)">
                                    {{ item.manufacturer ? item.manufacturer.name : '' }}
                                </td>
                                <td class="description" @click="openItem(item.id)" v-html="getDescription(item.localizations)"></td>
                                <td class="amount" @click="openItem(item.id)">{{ item.stock_count_total }}</td>
                                <td v-if="lowStockFilterActive">
                                    <button v-if="!item.reordered_by" class="button is-secondary" @click="onReorder(item, true)">Genbestilt</button>
                                    <div v-else style="display: flex; align-items: center; gap: 8px; white-space: nowrap;">
                                        <span @click="onReorder(item, false)" style="font-size: 12px; cursor: pointer;">
                                            <i class="fas fa-times"></i>
                                        </span>
                                        <span><span style="font-weight: 600;">{{ item.reordered_by }}</span> ({{ formatDate(item.reordered_at) }})</span>
                                    </div>
                                </td>
                                <td class="edit">
                                    <a class="button is-small" @click="openModal(item)">
                                        <span class="icon">
                                            <i class="fas fa-edit"></i>
                                        </span>
                                    </a>
                                </td>
                            </tr>
                            </tbody>
                            <tbody v-else>
                            <tr v-for="index in skeletonRows" :key="index">
                                <td class="model">
                                    <b-skeleton :animated="true"></b-skeleton>
                                </td>
                                <td class="manufacturer">
                                    <b-skeleton :animated="true"></b-skeleton>
                                </td>
                                <td class="description">
                                    <b-skeleton :animated="true"></b-skeleton>
                                </td>
                                <td class="amount">
                                    <b-skeleton :animated="true"></b-skeleton>
                                </td>
                                <td class="edit">
                                    <span class="icon is-small">
                                        <b-skeleton></b-skeleton>
                                    </span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="mt-2" v-if="!isFetching">
                        <b-pagination
                            v-model="currentPage"
                            :per-page="pagination.per_page"
                            :total="pagination.total"
                            @change="paginate"
                            order="is-right">
                        </b-pagination>
                    </div>
                </div>
                <div v-else key="grid">
                    <div class="grids" v-if="!isFetching">
                        <div class="grid-item is-clickable" v-for="item in items" :key="item.id">
                            <div class="card" @click="openItem(item.id)">
                                <div class="card-image">
                                    <figure class="image is-4by3">
                                        <div v-if="item.images.length > 0"><img :src="item.images[0].url"
                                                                                :alt="item.model" class="grid-item-image"></div>
                                        <div class="image-empty" v-else></div>
                                        <p class="is-link card-image__stock">{{ item.stock_count_total }} på lager</p>
                                    </figure>
                                </div>
                                <div class="card-content">
                                    <div class="content">
                                        <p><strong>{{ item.model }}</strong></p>
                                        <p><em>{{ item.manufacturer ? item.manufacturer.name : '-' }}</em></p>
                                        <p v-html="getDescription(item.localizations)"></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="grids" v-else>
                        <div class="grid-item" v-for="index in skeletonRows" :key="index">
                            <div class="card" style="width: 100%;">
                                <div class="card-image">
                                    <figure class="image is-4by3">
                                        <b-skeleton :animated="true" height="100%"></b-skeleton>
                                    </figure>
                                </div>
                                <div class="card-content">
                                    <div class="content">
                                        <b-skeleton :animated="true"></b-skeleton>
                                        <b-skeleton :animated="true"></b-skeleton>
                                        <b-skeleton :animated="true"></b-skeleton>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="mt-6" v-if="!isFetching">
                        <b-pagination
                            v-model="currentPage"
                            :per-page="pagination.per_page"
                            :total="pagination.total"
                            @change="paginate"
                            order="is-right">
                        </b-pagination>
                    </div>
                </div>
            </transition-group>
        </div>

        <ItemModal
            v-if="modalOpen"
            :active="modalOpen"
            :item="modalItem"
            @closed="closeModal"
            @updated="onItemUpdated"
            @showHistory="openCostPriceHistoryModal"
            @confirmCostPrice="onConfirmCostPrice"
            ref="itemModal"
        />

        <PriceHistoryModal
            :active="showPriceHistoryModal"
            :item="modalItem"
            @closed="onCloseHistoryModal" />

        <ImportErrorsModal
            v-if="importErrorsModalOpen"
            :active="importErrorsModalOpen"
            :errors="importErrorsModalErrors"
            @closed="closeImportErrorsModal"
        />

        <ImportHelpModal
            v-if="importHelpModalOpen"
            :active="importHelpModalOpen"
            @closed="closeImportHelpModal"
        />
    </section>
</template>

<script>
import PageHeader from '@elems/pageHeader'
import {mapGetters, mapActions} from 'vuex'
import ItemModal from './forms/ItemModal';
import ImportErrorsModal from './show/ImportErrorsModal';
import ImportHelpModal from './show/ImportHelpModal';
import debounce from 'lodash/debounce'
import {InputSelect, InputSelectSearch, InputCheckbox, FormField} from '@elems/form'
import SortArrow from '@elems/SortArrow'
import PriceHistoryModal from "@elems/prices/show/PriceHistoryModal";
const moment = require("moment");

export default {
    components: {
        PageHeader,
        ItemModal,
        InputSelect,
        InputSelectSearch,
        ImportErrorsModal,
        ImportHelpModal,
        SortArrow,
        PriceHistoryModal,
        FormField,
        InputCheckbox
    },
    data() {
        return {
            displayType: 'list',
            modalOpen: false,
            modalItem: null,
            query: '',
            skeletonRows: 20,
            currentPage: 1,
            itemTypeId: 0,
            manufacturerId: 0,
            supplierId: 0,
            location: null,
            priceTypeId: 0,
            deliveryTypeId: 0,
            manufacturerPriceTypeId: 0,
            categoryId: 0,
            subcategoryId: 0,
            documentGroupId: 0,
            propertyId: 0,
            termId: 0,
            soldOnWebShop: 0,
            activeFilters: false,
            lowStockFilterActive: false,
            lowStockFilterKey: 'low-stock',
            lowStockCount: 0,
            items: [],
            isFetching: false,
            pagination: { total: 0 },
            params: {},
            importErrorsModalOpen: false,
            importErrorsModalErrors: null,
            importHelpModalOpen: false,
            orderBy: null,
            direction: null,
            showPriceHistoryModal: false,
        }
    },
    computed: {
        ...mapGetters([
            'listItemTypes',
            'listManufacturers',
            'listSuppliers',
            'listLocations',
            'listPriceTypes',
            'listItemCategories',
            'listDocumentGroups'
        ]),
        itemCategoryOptions() {
            return this.listItemCategories.filter((category) => category.subcategoriesFlatten.length > 0);
        }
    },
    methods: {
        formatDate(date) {
            return moment(date).format('DD. MMM YYYY');
        },
        onReorder(item, reorder = true) {
            window.axios.post('/api/items/' + item.id + '/reorder', { reorder })
                .then((response) => {
                    item.reordered_by = response.data.reordered_by;
                    item.reordered_at = response.data.reordered_at;
                    // this.fetchItems();
                })
                .catch(error => {
                    console.error(error)
                });
        },
        onConfirmCostPrice(price) {
            if (!confirm('Er du sikker på at du vil bekræfte kostprisen?')) {
                return
            }

            window.axios.post('/api/items/' + this.modalItem.id + '/cost-price/confirm')
                .then((response) => {
                    this.modalItem.cost_price.outdated = false;
                })
                .catch(error => {
                    console.error(error)
                });
        },
        openCostPriceHistoryModal() {
            this.showPriceHistoryModal = true;
        },
        onCloseHistoryModal() {
            this.showPriceHistoryModal = false;
        },
        filterLocations(options, search) {
            const terms = search.toLocaleLowerCase().split(' ');
            return options.filter(option => {
                return terms.every(term => {
                    return option.full_name.toLocaleLowerCase().indexOf(term) > -1
                });
            });
        },
        getDescription(localizations) {
            const descriptions = localizations.filter((localization) => localization.key === 'description').sort((a, b) => a.locale_id - b.locale_id);

            const da = descriptions.find((description) => description.locale?.code === 'da');

            if (da) {
                return da.value;
            }

            if (descriptions.length) {
                return descriptions[0].value;
            }

            return '';
        },
        disableTab(event){
        },
        toggleDirection() {
            this.direction = (this.direction === 'asc') ? 'desc' : 'asc';
        },
        onUpdateOrderBy(key) {
            this.toggleDirection();
            this.orderBy = key;
            this.updateParamsAndFetch();
        },
        openDialog(ref) {
            this.$refs[ref].click()
        },
        itemImport(event) {
            if (event.target.files.length) {
                let formData = new FormData();
                formData.append('file', event.target.files[0]);
                window.axios.post(`/api/item-import`, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(({ data }) => {
                        this.$store.dispatch('setSuccess', `Varerne blev importeret (${data.count})`)
                        this.onItemUpdated();
                    })
                    .catch(error => {
                        this.importError(error)
                    });
                event.target.value = null;
            }
        },
        stockImport(event) {
            if (event.target.files.length) {
                let formData = new FormData();
                formData.append('file', event.target.files[0]);
                window.axios.post(`/api/item-stock-import`, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(({ data }) => {
                        this.$store.dispatch('setSuccess', `Lagerstatus blev importeret (${data.count})`)
                        this.onItemUpdated();
                    })
                    .catch(error => {
                        this.importError(error)
                    });
                event.target.value = null;
            }
        },
        importError(error) {
            if (error.response.data.message) {
                this.$store.dispatch('setError', error.response.data.message)
            }
            else {
                this.importErrorsModalErrors = error.response.data
                this.importErrorsModalOpen = true
            }
        },
        noSerialExport() {
            this.itemExport('no_serial')
        },
        withSerialExport() {
            this.itemExport('with_serial')
        },
        serviceExort() {
            this.itemExport('service')
        },
        itemExport(itemTypeKey) {
            const params = { itemTypeKey: itemTypeKey }
            window.axios.get('/api/item-export', { params })
                .then((response) => {
                    this.downloadCsv(response)
                    this.$store.dispatch('setSuccess', 'Varerne blev eksporteret');
                })
                .catch(error => {
                    this.$store.dispatch('setError', 'Der opstod en fejl')
                });
        },
        csvResponse(route, title) {
            window.axios.get(`/api/${route}`)
                .then((response) => {
                    this.downloadCsv(response)
                    this.$store.dispatch('setSuccess', `${title} blev eksporteret`);
                })
                .catch(error => {
                    this.$store.dispatch('setError', 'Der opstod en fejl')
                });
        },
        stockExportNoSerial() {
            this.csvResponse('item-stock-export-no-serial', 'Lagerstatus u. serienummer');
        },
        stockExportWithSerial() {
            this.csvResponse('item-stock-export-with-serial', 'Lagerstatus m. serienummer');
        },
        stockLocationExportNoSerial() {
            this.csvResponse('item-stock-location-export-no-serial', 'Lagerstatus pr. lokation u. serienummer');
        },
        stockLocationExportWithAndWithoutSerial() {
            this.csvResponse('item-stock-export-with-without-serial', 'Lagerstatus med/uden serienummer');
        },
        stockLocationExportWithSerial() {
            this.csvResponse('item-stock-location-export-with-serial', 'Lagerstatus pr. lokation m. serienummer');
        },
        downloadCsv(response) {
            const url = window.URL.createObjectURL(new Blob(["\ufeff"+response.data]));
            const cd = response.headers['content-disposition'];
            let fileLink = document.createElement('a');
            fileLink.href = url;
            fileLink.setAttribute('download', cd.match(/filename=(.+)/)[1]);
            document.body.appendChild(fileLink);
            fileLink.click();
            fileLink.remove();
        },
        title() {
            return `Varer (${this.pagination.total ? this.pagination.total : 0})`
        },
        openSerials() {
            this.$router.push({
                name: 'serials',
            });
        },
        openItem(id) {
            this.$router.push({
                name: 'items',
                params: {
                    id,
                },
            });
        },
        openModal(item) {
            this.modalItem = item
            this.modalOpen = true
        },
        openImportHelpModal() {
            this.importHelpModalOpen = true
        },
        closeImportHelpModal() {
            this.importHelpModalOpen = false
        },
        closeModal() {
            this.modalOpen = false
            this.modalItem = null
        },
        closeImportErrorsModal() {
            this.importErrorsModalOpen = false
            this.importErrorsModalErrors = null
        },
        paginate(value) {
            this.currentPage = value;
            this.updateParamsAndFetch();
        },
        search: debounce(function () {
            this.currentPage = 1;
            this.updateParamsAndFetch();
        }, 200),
        updateParamsAndFetch() {
            this.updateParams();
            this.fetchItems();
        },
        updateParams() {
            this.params = {};
            let filters = [];

            //Filters
            if (this.query) this.params['q'] = this.query;
            if (this.itemTypeId > 0) this.params['type'] = this.itemTypeId;
            if (this.manufacturerId > 0) this.params['manufacturer'] = this.manufacturerId;
            if (this.supplierId > 0) this.params['supplier'] = this.supplierId;
            if (this.location) this.params['location'] = this.location.id;
            if (this.priceTypeId > 0) this.params['price-type'] = this.priceTypeId;
            if (this.deliveryTypeId > 0) this.params['delivery-type'] = this.deliveryTypeId;
            if (this.manufacturerPriceTypeId > 0) this.params['manufacturer-price-type'] = this.manufacturerPriceTypeId;
            if (this.subcategoryId > 0) this.params['subcategory'] = this.subcategoryId;
            if (this.categoryId > 0) this.params['category'] = this.categoryId;
            if (this.propertyId > 0) this.params['property'] = this.propertyId;
            if (this.termId > 0) this.params['term'] = this.termId;
            if (this.documentGroupId > 0) this.params['document-group'] = this.documentGroupId;

            if (this.soldOnWebShop !== 0) this.params['sold-on-webshop'] = this.soldOnWebShop;
            if (this.orderBy) this.params['order-by'] = this.orderBy;
            if (this.direction) this.params['direction'] = this.direction;
            if (this.lowStockFilterActive) filters.push(this.lowStockFilterKey);
            if (filters.length) this.params['filters'] = filters.join(',');

            this.activeFilters = Object.keys(this.params).length

            //Pagination and list type
            if (this.currentPage > 1) this.params['page'] = this.currentPage;
            if (this.displayType !== 'list') this.params['display'] = this.displayType;

            this.$router.push({ path: '/items', query: this.params })
        },
        fetchItems() {
            this.isFetching = true
            this.params['with'] = 'manufacturer,images,localizations.locale,terms.property,compatibles.manufacturer'
            const params = this.params;

            window.axios.get('/api/items', { params })
                .then(({ data }) => {
                    this.items = data.data
                    this.pagination = data.meta
                    this.isFetching = false
                })
                .catch(error => {
                    console.error(error)
                    this.isFetching = true
                });
        },
        isId(value) {
            return /^[1-9]\d*$/.test(value)
        },
        resetFilters() {
            this.query = ''
            this.lowStockFilterActive = false
            this.itemTypeId = 0
            this.subcategoryId = 0
            this.categoryId = 0
            this.propertyId = 0
            this.termId = 0
            this.soldOnWebShop = 0
            this.manufacturerId = 0
            this.supplierId = 0
            this.location = null
            this.priceTypeId = 0
            this.deliveryTypeId = 0
            this.manufacturerPriceTypeId = 0
            this.documentGroupId = 0
            this.orderBy = null
            this.direction = null
            this.updateParamsAndFetch();
        },
        toggleLowStock() {
            this.lowStockFilterActive = !this.lowStockFilterActive
            this.updateParamsAndFetch();
        },
        updateLowStockCount() {
            window.axios.get('/api/items/low-stock')
                .then((data) => {
                    this.lowStockCount = data.data
                })
                .catch(error => {
                    console.error(error)
                });
        },
        onItemUpdated() {
            this.updateLowStockCount();
            this.fetchItems();
        },
        toggleDisplayType(listType = 'list') {
            this.displayType = listType;
            this.updateParams();
        },
        parseId(value, defaultValue = 0) {
            return value && this.isId(value) ? parseInt(value) : defaultValue;
        },
    },
    created() {
        let params = new URLSearchParams(window.location.search)
        this.query = params.get('q');

        this.currentPage = this.parseId(params.get('page'), 1);
        this.itemTypeId = this.parseId(params.get('type'));
        this.manufacturerId = this.parseId(params.get('manufacturer'));
        this.supplierId = this.parseId(params.get('supplier'));
        if (params.get('location')) {
            this.location = {
                id: this.parseId(params.get('location')),
                full_name: ''
            }
        }

        this.priceTypeId = this.parseId(params.get('price-type'));
        this.deliveryTypeId = this.parseId(params.get('delivery-type'));
        this.manufacturerPriceTypeId = this.parseId(params.get('manufacturer-price-type'));
        this.categoryId = this.parseId(params.get('category'));
        this.subcategoryId = this.parseId(params.get('subcategory'));
        this.propertyId = this.parseId(params.get('property'));
        this.termId = this.parseId(params.get('term'));
        this.documentGroupId = this.parseId(params.get('document-group'));
        this.displayType = params.get('display') || 'list';
        this.orderBy = params.get('order-by') || null;
        this.direction = params.get('direction') || null;

        const filters = params.get('filters');

        if (filters) {
            filters.split(',').forEach((filter) => {
                if (filter == this.lowStockFilterKey)
                    this.lowStockFilterActive = true;
            })
        }

        this.updateParamsAndFetch();
    },
    mounted() {
        this.$store.dispatch('loadItemTypes');
        this.$store.dispatch('loadManufacturer');
        this.$store.dispatch('loadLocations');
        this.$store.dispatch('loadPriceTypes');
        this.$store.dispatch('loadSuppliers');
        this.$store.dispatch('loadItemCategories');
        this.updateLowStockCount();
    },

    watch: {
        listLocations() {
            let params = new URLSearchParams(window.location.search)
            this.location = this.listLocations.find((location) => location.id == params.get('location'));
        },
    }
}
</script>

<style scoped>
.table.inventory {
    margin-top: 1.5rem;
}

.model {
    width: 15%;
    cursor: pointer;
}

.manufacturer {
    width: 15%;
    cursor: pointer;
}

.description {
    width: 55%;
    cursor: pointer;
}

.amount {
    width: 15%;
    text-align: right;
    cursor: pointer;
}

.edit {
    text-align: right;
    cursor: default;
}
</style>

<style lang="scss">
.grids {
    display: grid;
    //grid-auto-rows: 1fr;
    grid-column-gap: 15px;
    grid-row-gap: 25px;
    grid-template-columns: repeat(1, 1fr);

    @media screen and (min-width: 768px) {
        grid-template-columns: repeat(3, 1fr);
    }

    @media screen and (min-width: 1024px) {
        grid-template-columns: repeat(4, 1fr);
    }
}

.grid-item-image {
    width: auto !important;
    left: 50% !important;
    transform: translateX(-50%) !important;
}

.grid-item {
    display: flex;

    .card {
        width: 100%;
    }
    .card-image {
        .image-empty {
            position: absolute;
            top: 0;
            bottom: 0;
            background: #ccc;
            height: 100%;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            border-top-left-radius: 0.25rem;
            border-top-right-radius: 0.25rem;

            &::after {
                content: 'Intet billede';
            }
        }

        .b-skeleton.is-animated {
            position: absolute;
            top: 0;
            bottom: 0;
        }
    }
}

.hide-dots .pagination-list {
    display: none;
}

.slide-fade-enter-active {
    transition: all .3s ease;
    transition-delay: 320ms;
}

.slide-fade-leave-active {
    transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter, .slide-fade-leave-to {
    transform: translateY(1rem);
    transform-origin: top center;
    opacity: 0;
}


.content p:not(:last-child) {
    margin-bottom: 0.5em;
}

.card-image__stock {
    position: absolute;
    top: 15px;
    left: 0px;
    background: #035980;
    color: #fff;
    font-size: 0.9em;
    padding: 5px 10px;
}
</style>
